import { useEffect, useState } from 'react';

/**
 * Returns true when the viewport width is at or below the given breakpoint.
 * Defaults to 760px to align with the mobile layout breakpoint used in admin/artist pages.
 */
export default function useIsMobileLayout(breakpoint = 760) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }

    const query = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const handleChange = (event) => setIsMobile(event.matches);

    // Initialize immediately so the first render is accurate after hydration.
    setIsMobile(query.matches);

    if (typeof query.addEventListener === 'function') {
      query.addEventListener('change', handleChange);
      return () => query.removeEventListener('change', handleChange);
    }

    query.addListener(handleChange);
    return () => query.removeListener(handleChange);
  }, [breakpoint]);

  return isMobile;
}
